import React from 'react';
import { withRouter } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import ProductBrowserMobView from 'components/organisms/productBrowserMobile';
import ProductBrowserSlickDesk from 'components/organisms/productBrowserSlickDesk';
import { useViewport } from 'components/templates/viewportProvider';
//eslint-disable-next-line
import styles from "./styles.scss";

const ProductBrowserList = props => {
  const {
    data,
    match: { params },
  } = props;
  const { height } = useViewport();
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-device-width: 1224px)',
  });
  const isBigScreen = useMediaQuery({ query: '(min-device-width: 1824px)' });
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
  const isTabletOrMobileDevice = useMediaQuery({
    query: '(max-device-width: 1224px)',
  });

  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });

  if (!data.productData) {
    return null;
  }
  return (
    <div style={{ height }} id={'products'}>
      {(isDesktopOrLaptop || isBigScreen || isPortrait === false) && (
        <>
          <ProductBrowserSlickDesk
            breadCrumb={data.breadcrumb}
            productData={data.productData}
            isParam={params}
            onGetInTouchClick={data.onGetInTouchClick}
            project={data.projectDetails}
            productsSelector={data.productsSelector}
            productDescription={
              data.projectDetails
                ? data.projectDetails.productsDescription
                : null
            }
            type={data.type}
          />
        </>
      )}

      {(isTabletOrMobileDevice || isTabletOrMobile) && isPortrait === true && (
        <>
          <ProductBrowserMobView
            productData={data.productData}
            isParam={params}
            onGetInTouchClick={data.onGetInTouchClick}
            project={data.projectDetails}
            productsSelector={data.productsSelector}
            type={data.type}
          />
        </>
      )}
    </div>
  );
};

export default withRouter(ProductBrowserList);
